import React, { createContext, useContext, useState, useCallback } from 'react';

interface ChannelDocumentsContextValue {
  showChannelDocPanel: boolean;
  channelDocChannelId: string | null;
  openEventId: number;
  openChannelDocPanel: (channelId: string | null) => void;
  closeChannelDocPanel: () => void;
}

const ChannelDocumentsContext = createContext<ChannelDocumentsContextValue>({
  showChannelDocPanel: false,
  channelDocChannelId: null,
  openEventId: 0,
  openChannelDocPanel: () => {},
  closeChannelDocPanel: () => {},
});

export const useChannelDocuments = () => useContext(ChannelDocumentsContext);

export const ChannelDocumentsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showChannelDocPanel, setShowChannelDocPanel] = useState(false);
  const [channelDocChannelId, setChannelDocChannelId] = useState<string | null>(null);
  const [openEventId, setOpenEventId] = useState(0);

  const openChannelDocPanel = useCallback((channelId: string | null) => {
    setChannelDocChannelId(channelId);
    setShowChannelDocPanel(true);
    setOpenEventId(prev => prev + 1);
  }, []);

  const closeChannelDocPanel = useCallback(() => {
    setShowChannelDocPanel(false);
    setChannelDocChannelId(null);
  }, []);

  return (
    <ChannelDocumentsContext.Provider value={{ showChannelDocPanel, channelDocChannelId, openEventId, openChannelDocPanel, closeChannelDocPanel }}>
      {children}
    </ChannelDocumentsContext.Provider>
  );
};
